import { postElegibilidad, putElegibidad } from '../../config/apiSinToken'

export const updateLocation = async (form) => {
  const data = await putElegibidad(
    `api/v1/ProjectDevelopmentLocation/updateLocation`,
    form,
  )
  return data
}

export const updateAssetsLossClimate = async (form) => {
  const data = await putElegibidad(`api/v1/AssetsLossClimate/updateAsset`, form)
  return data
}

export const updateProductionAndLossed = async (form) => {
  const data = await putElegibidad(
    `api/v1/ProductionAndLossesByClimate/updateProductionAndLoss`,
    form,
  )
  return data
}

// Funcion para la tabla 3.9.1
export const updateActivity = async (form) => {
  const data = await putElegibidad(
    `api/v1/ProductiveActivitiesPlanning/updateActivity`,
    form,
  )
  return data
}

// Funcion para la tabla 3.9.3
export const updateBarrier = async (form) => {
  const data = await putElegibidad(
    `api/v1/MarketAccessBarriers/updateBarrier`,
    form,
  )
  return data
}

// Funcion para la tabla 3.9.6
export const updateEnergyUsedProduction = async (form) => {
  const data = await putElegibidad(`api/v1/EnergyUsedProduction/update`, form)
  return data
}

// Funcion para la tabla 3.9.9
export const updateManagementSoilsPractices = async (form) => {
  const data = await putElegibidad(
    `api/v1/ManagementSoilsPractices/update`,
    form,
  )
  return data
}

// Funcion para la tabla 4.1 seccion 4
export const updateGenderActivities = async (form) => {
  const data = await putElegibidad(`api/v1/GenderActivities/update`, form)
  return data
}

// Funcion para la tabla 5.2 seccion 5
export const updateAdaptationMeasures = async (form) => {
  const data = await putElegibidad(`api/v1/AdaptationMeasures/update`, form)
  return data
}

// Funcion para la tabla 3.9.5 seccion 3
export const UpdateServicesAccess = async (form) => {
  const data = await putElegibidad(
    `api/v1/ServicesAccess/UpdateServicesAccess`,
    form,
  )
  return data
}

// Funcion para el modal 3.9.8
export const UpdateUsedFertilizers = async (form) => {
  const data = await postElegibilidad(`api/v1/UsedFertilizers/update`, form)
  return data
}

// Funcion para la tabla 5.3(tableGanttDev) seccion 5
export const UpdateImplementationSchedule = async (form) => {
  const data = await putElegibidad(`api/v1/ImplementationSchedule/update`, form)
  return data
}

// Funcion para la tabla 5.3(tableGanttDev) seccion 5
export const UpdateSubprojectBudget = async (form) => {
  const data = await putElegibidad(`api/v1/SubprojectBudget/update`, form)

  return data
}
// Funcion
export const UpdateManagementPlanMitigation = async (form) => {
  const data = await putElegibidad(
    `api/v1/ManagementPlanMitigations/update`,
    form,
  )
  return data
}

export const UpdateEnviromentalManagementPlan = async (params) => {
  const data = await putElegibidad(
    `api/v1/EnvironmentalManagementPlan/update/?idElegibilityAnswer=${params.idElegibilityAnswer}&idEnvironmentalImpact=${params.idEnvironmentalImpact}&isChek=${params.isChek}`,
    {},
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 07-11-2022
 * Description: Funcion para guardar las respuestas del workshop
 */
export const updateTestAnswerWorkshop = async (form) => {
  const data = await putElegibidad(`api/v1/Workshop/Test/Answer/Update`, form)
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 10-11-2022
 * Description: Funcion para actualizar el status del test
 */
export const updateTestStatus = async ({
  IdTest,
  IdWorkshopStatus,
  ApprovedQuestions,
}) => {
  const data = await putElegibidad(
    `api/v1/Workshop/Workshop-Update/test/${IdTest}/${IdWorkshopStatus}/${ApprovedQuestions}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 10-11-2022
 * Description: Funcion para actualizar el status del workshop
 */
export const updateWorkShopStatus = async ({
  CodWorkshop,
  IdWorkshopStatus,
}) => {
  const data = await putElegibidad(
    `api/v1/Workshop/Workshop-Update/${CodWorkshop}/${IdWorkshopStatus}`,
  )
  return data
}
